<template>
  <div class="col-12" style="margin-top:4px;">
    <h5>Cow List
     <b-btn
          class="btn-danger float-right"
           style="text-align: right;"
          @click="back()"
        >
         <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
        </b-btn></h5>
    <hr/>
    <div class=" col-sm-12">
      <input
        type="text"
        class="form-control"
        placeholder="search"
        style="width: 60%; margin-left:1px"
      />
    </div>&nbsp;
 <div class="row" style="margin: 0px">
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="handleDetails">
            <img
              src="../assets/114.jpg"
              height="150px"
              width="140px"
              style="object-fit: cover; padding-right: 15px"
            />
            <div class="row">
              <div
                class="col-12"
                style="
                  font-family: Arial;
                  font-size: 18px;
                  padding: 20px;
                  padding-bottom: 0px;
                "
              >
                <table>
                  <tr>
                    <th>Name:</th>
                    <td>Cow</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>8</td>
                  </tr>
                   <tr>
                    <th>Amount:</th>
                    <td>10000</td>
                  </tr>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="handleDetails">
            <img
              src="../assets/114.jpg"
              height="150px"
              width="140px"
              style="object-fit: cover; padding-right: 15px"
            />
            <div class="row">
              <div
                class="col-12"
                style="
                  font-family: Arial;
                  font-size: 18px;
                  padding: 20px;
                  padding-bottom: 0px;
                "
              >
                <table>
                  <tr>
                    <th>Name:</th>
                    <td>Cow</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>9</td>
                  </tr>
                   <tr>
                    <th>Amount:</th>
                    <td>11000</td>
                  </tr>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="handleDetails">
            <img
              src="../assets/114.jpg"
              height="150px"
              width="140px"
              style="object-fit: cover; padding-right: 15px"
            />
            <div class="row">
              <div
                class="col-12"
                style="
                  font-family: Arial;
                  font-size: 18px;
                  padding: 20px;
                  padding-bottom: 0px;
                "
              >
                <table>
                  <tr>
                    <th>Name:</th>
                    <td>Cow</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>10</td>
                  </tr>
                  <tr>
                    <th>Amount:</th>
                    <td>13000</td>
                  </tr>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="handleDetails">
            <img
              src="../assets/114.jpg"
              height="150px"
              width="140px"
              style="object-fit: cover; padding-right: 15px"
            />
            <div class="row">
              <div
                class="col-12"
                style="
                  font-family: Arial;
                  font-size: 18px;
                  padding: 20px;
                  padding-bottom: 0px;
                "
              >
                <table>
                  <tr>
                    <th>Name:</th>
                    <td>Cow</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>13</td>
                  </tr>
                  <tr>
                    <th>Amount:</th>
                    <td>14000</td>
                  </tr>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
       <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="handleDetails">
            <img
              src="../assets/114.jpg"
              height="150px"
              width="140px"
              style="object-fit: cover; padding-right: 15px"
            />
            <div class="row">
              <div
                class="col-12"
                style="
                  font-family: Arial;
                  font-size: 18px;
                  padding: 20px;
                  padding-bottom: 0px;
                "
              >
                <table>
                  <tr>
                    <th>Name:</th>
                    <td>Cow</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>13</td>
                  </tr>
                  <tr>
                    <th>Amount:</th>
                    <td>14000</td>
                  </tr>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
       <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="handleDetails">
            <img
              src="../assets/114.jpg"
              height="150px"
              width="140px"
              style="object-fit: cover; padding-right: 15px"
            />
            <div class="row">
              <div
                class="col-12"
                style="
                  font-family: Arial;
                  font-size: 18px;
                  padding: 20px;
                  padding-bottom: 0px;
                "
              >
                <table>
                  <tr>
                    <th>Name:</th>
                    <td>Cow</td>
                  </tr>
                  <tr>
                    <th>Age:</th>
                    <td>13</td>
                  </tr>
                  <tr>
                    <th>Amount:</th>
                    <td>14000</td>
                  </tr>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
    </div>
    <br />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
     handleDetails() {
      this.$router.push("/myCowviewdetails");
    },
  },
};
</script>

<style>
</style>